import * as React from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

/**
 * PageTransition
 * ------------------------------------------------------------------------------
 * Subtle fade on route change, but IMPORTANTLY:
 * - No animation on the first mount (so intro/caption timing isn't masked).
 */
export default function PageTransition({ location, children }) {
  const reduce = useReducedMotion();
  const hasMountedRef = React.useRef(false);

  React.useEffect(() => {
    hasMountedRef.current = true;
  }, []);

  // First render: don't animate (prevents caption fade getting “hidden”)
  if (!hasMountedRef.current) {
    return <>{children}</>;
  }

  const duration = reduce ? 0 : 0.45;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location?.pathname || "page"}
        initial={{ opacity: 0, filter: "blur(4px)" }}
        animate={{ opacity: 1, filter: "blur(0px)" }}
        exit={{ opacity: 0, filter: "blur(4px)" }}
        transition={{ duration, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
